const API_BASE_URL = "https://kb33pukdn9.execute-api.us-east-1.amazonaws.com/dev"; // Change this to your desired base URL
export default API_BASE_URL;
